<template>
  <div class="main">
    <div class="bg">
      <img src="../assets/poker/bg2.png" />
    </div>
    <div class="msg">
      <div v-if="disable" class="title">審核中，通過即可參與抽獎</div>
      <div v-else class="title">請輸入用戶ID以完成綁定</div>
      <template v-if="!disable">
        <div class="id-region">
          <el-input
            class="id-unit"
            inputmode="numeric"
            ref="id0"
            @input="GGID[0].length ? $refs.id1.focus() : $refs.id0.focus()"
            v-model="GGID[0]"
            maxlength="1"
            :disabled="disable"
          ></el-input>
          <el-input
            class="id-unit"
            inputmode="numeric"
            ref="id1"
            @input="GGID[1].length ? $refs.id2.focus() : $refs.id0.focus()"
            v-model="GGID[1]"
            maxlength="1"
            :disabled="disable"
          ></el-input>
          <el-input
            class="id-unit"
            inputmode="numeric"
            ref="id2"
            @input="GGID[2].length ? $refs.id3.focus() : $refs.id1.focus()"
            v-model="GGID[2]"
            maxlength="1"
            :disabled="disable"
          ></el-input>
          <el-input
            class="id-unit"
            inputmode="numeric"
            ref="id3"
            @input="GGID[3].length ? $refs.id4.focus() : $refs.id2.focus()"
            v-model="GGID[3]"
            maxlength="1"
            :disabled="disable"
          ></el-input>
          <el-input
            class="id-unit"
            inputmode="numeric"
            ref="id4"
            @input="GGID[4].length ? $refs.id5.focus() : $refs.id3.focus()"
            v-model="GGID[4]"
            maxlength="1"
            :disabled="disable"
          ></el-input>
          <el-input
            class="id-unit"
            inputmode="numeric"
            ref="id5"
            @input="GGID[5].length ? $refs.id5.focus() : $refs.id4.focus()"
            v-model="GGID[5]"
            maxlength="1"
            :disabled="disable"
          ></el-input>
        </div>
        <div class="button-region">
          <el-button type="info" :disabled="disable" @click="clear"
            >清除</el-button
          >
          <el-button type="success" :disabled="disable" @click="save"
            >綁定</el-button
          >
        </div>
      </template>
      <div v-if="disable" class="id-img-prize" @click="goLucky"></div>
      <div v-else class="id-img"></div>
    </div>
    <b-modal
      class="delete-modal"
      v-model="modalShow"
      @hidden="closeLiff"
      centered
      hide-footer
      hide-header
    >
      <div class="modal-div-d">提交成功，審核會在一天內生效</div>
      <div class="ok" @click="handleOk">確認</div>
    </b-modal>
    <b-modal
      class="delete-modal"
      v-model="alertShow"
      @hidden="alertMsg = ''"
      centered
      hide-footer
      hide-header
    >
      <div class="modal-div-d">{{alertMsg}}</div>
      <div class="ok" @click="alertShow = false">確認</div>
    </b-modal>
  </div>
</template>

<script>
import liff from "@line/liff";
import axios from "axios";

export default {
  name: "bind",
  props: {
    liffAccessToken: "",
    user: [Object, null],
  },

  data() {
    return {
      GGID: [],
      modalShow: false,
      alertShow: false,
      disable: false,
      alertMsg:""
    };
  },
  mounted() {
    this.disable = this.user.clubGGId && !this.user.clubGGIdReviewed;
  },
  methods: {
    goLucky(){
      this.$router.push({ path: '/lucky'})
    },
    closeLiff() {
      liff.closeWindow();
    },
    handleOk() {
      this.modalShow = false;
    },
    clear() {
      this.GGID = [];
    },
    async save() {
      for(let i = 0; i < 6; i++){
        if(((this.GGID[i] == undefined) || (this.GGID[i] == ''))){
          this.alertMsg = "ID有誤"
          this.alertShow = true;
          return;
        }
      }
      let clubGGId = this.GGID.join("");
      try {
        await axios({
          method: "post",
          url: "/user/bind",
          data: { clubGGId },
          headers: {
            "Content-Type": "application/json",
            "Access-Token": this.liffAccessToken,
          },
        });
        this.modalShow = true;
      } catch (err) {
        if (err.response.status === 409) {
          alert('此 ID 已被他人綁定');
        } else {
          alert('系統異常，請稍候再試');
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.id-img {
  background: url("../assets/poker/getID2.jpg") no-repeat center top;
  width: 100%;
  height: 36rem;
  margin-top: 1rem;
  background-size: 84%;
}
.id-img-prize {
  background: url("../assets/poker/prize2.jpg") no-repeat center top;
  width: 100%;
  height: 32rem;
  margin-top: 1rem;
  background-size: 100%;
}
.id-region {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.id-unit {
  width: 32px;
}
.id-unit/deep/.el-input__inner {
  padding: 0 10px;
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -999;
}
.bg img {
  min-height: 100%;
  width: 100%;
}
.main {
  display: flex;
  justify-content: center;
  align-items: center;
}
.msg {
  font-size: 1.4rem;
  text-align: center;
  word-wrap: break-word;
  width: 90%;
  height: 50%;
  color: black;
  background-color: burlywood;
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 0.8rem;
}

.bg-dark {
  background-color: #343a40cc !important;
}
/deep/.modal-content {
  width: 90%;
  left: 5%;
  background-color: #000c;
  color: wheat;
  border-radius: 1rem;
}
.modal-div-edit {
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-div {
  // margin: 1rem;
  word-wrap: break-word;
  text-align: center;
}
.modal-div-d {
  margin: 1rem;
  word-wrap: break-word;
  text-align: center;
}
.modal-comment {
  border: 1px solid wheat;
  margin-top: 4px;
}
.delete-modal {
  position: relative;
}
.ok {
  position: absolute;
  bottom: 12px;
  right: 20px;
  font-size: 0.9rem;
  color: silver;
}
</style>



// WEBPACK FOOTER //
// src/components/bind.vue